/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { CrossLocationPrerequisites } from "@microsoft/shifts-models-data";
// TODO: Replace 'sh-services' dependency from Web core with one from a workspace package.
import { NetworkService } from "sh-services";
import { DataProvider } from "sh-services/dataproviders/DataProvider";

import { CrossLocationPrerequisitesDataProviderParams } from "./CrossLocationPrerequisitesDataProviderParams";

/**
 * The team cross-location prerequisites data provider.
 */
export class CrossLocationPrerequisitesDataProvider extends DataProvider<CrossLocationPrerequisites> {
    /**
     * Instantiates a new instance of the CrossLocationPrerequisitesDataProvider.
     * @param params The parameters.
     */
    constructor(private readonly params: CrossLocationPrerequisitesDataProviderParams) {
        super();
    }

    /**
     * Not supported.
     */
    public async getDataFromMemory(): Promise<CrossLocationPrerequisites | undefined> {
        // Memory only stores view models, so returning undefined.
        return undefined;
    }

    /**
     * Not supported.
     */
    public async getDataFromDatabase(): Promise<CrossLocationPrerequisites | undefined> {
        // Not using persistent cache, so returning undefined.
        return undefined;
    }

    /**
     * Gets data from network call.
     * @returns The data from the network call.
     */
    public async getDataFromNetwork(): Promise<CrossLocationPrerequisites> {
        const { teamId } = this.params;
        const url = `/api/teams/${teamId}/schedule/verifyCrossLocationPrerequisites`;
        const urlSignature = "/api/teams/{teamId}/schedule/verifyCrossLocationPrerequisites";

        const { data: prerequisites } = await NetworkService.sendHttpRequestToStaffHubService<CrossLocationPrerequisites>({
            method: "POST",
            url,
            urlSignature
        });

        return prerequisites;
    }

    /**
     * Sets data in memory.
     * @param data The data to set in memory.
     */
    public async setDataInMemory(data: CrossLocationPrerequisites): Promise<void> {
        this.params.setDataInMemory(data);
    }

    /**
     * Not supported.
     */
    public async setDataInDatabase(): Promise<void> {
        return undefined;
    }

    /**
     * Not supported.
     */
    public async saveDataToNetwork(): Promise<CrossLocationPrerequisites | undefined> {
        return undefined;
    }
}
